import React from 'react';
import { APPOINTMENTS, APPOINTMENT_STATUS, REASSIGNED_MESSAGE } from '_constants';
import { fetchMemberAppointments, fetchEventDispositions, putUpdateAppointment } from '../services/appointments.services';
import _ from 'lodash';
import moment from 'moment';
import { showServerResponse } from './modals.actions';
import { isResponseSuccess } from 'helpers';
import { go, goBack } from 'connected-react-router';

export const hasPastdueAppointmets = (appointments = []) => {
  for (const i in appointments) {
    if (moment(appointments[i].startDate) < moment()) { return true; }
  }
  return false;
};

const updateCountIcon = () => (dispatch, getState) => {
  const currState = getState();
  const { appointments = [] } = currState.appointments;

  dispatch({
    type: APPOINTMENTS.UPDATE_BADGE_COUNT,
    displayCount: true,
    totalItemsCount: appointments.length
  });
};

const fetch = (start = null, end = null, monthOnly = false) => async (dispatch, getState) => {
  const memberKey = getState().userprofile.memberKey;
  const startDate = start || moment().subtract(APPOINTMENTS.MONTHS_LIMIT, 'months').startOf('month').format('MM/DD/YYYY');
  const endDate = end || moment().add(APPOINTMENTS.MONTHS_LIMIT, 'months').endOf('month').format('MM/DD/YYYY');
  const response = await dispatch(fetchMemberAppointments(memberKey, startDate, endDate));
  if (isResponseSuccess(response)) {
    const appointments = response.data;
    const filterOutTentativeAppointments = appointments.filter(appointment => appointment.eventStatus.id !== APPOINTMENT_STATUS.TENTATIVE.id);
    const monthAppointments = monthOnly ? filterOutTentativeAppointments : (filterOutTentativeAppointments || []).filter((val) => {
      return (moment(val.startDate).format('MMMM , YYYY') === moment().format('MMMM , YYYY'));
    });
    if (!monthOnly) {
      dispatch({ type: APPOINTMENTS.FETCH_APPOINTMENTS, value: filterOutTentativeAppointments || [] });
      dispatch({ type: APPOINTMENTS.STORE_ALL_APPOINTMENTS, value: appointments || [] });
    }
    const activeDate = getFirstOverdueAppt(monthAppointments);
    dispatch({ type: APPOINTMENTS.FETCH_MONTH_APPOINTENTS, value: { monthAppointments, activeDate } });
    dispatch(updateCountIcon());
  }
  return response; // TODO: handle catch and do something about it in the whole file.
};

const fetchDispositions = (id) => async (dispatch, getState) => {
  const eventDispositions = _.get(getState(), `appointments.dispositions[${id}]`, null);
  if (!eventDispositions) {
    const dispositionsResponse = await dispatch(fetchEventDispositions(id));
    if (isResponseSuccess(dispositionsResponse)) {
      dispatch({ type: APPOINTMENTS.FETCH_DISPOSITIONS, id: id, value: dispositionsResponse.data });
    }
    return dispositionsResponse.data; // TODO: handle catch
  }
  return eventDispositions;
};

const getAppointmentById = (appointments, id) => {
  if (!id || !appointments || !appointments.appointments || appointments.appointments.length === 0) { return null; }
  var filteredAppointments = appointments.appointments.filter(a => a.id.toString() === id.toString());
  if (filteredAppointments.length === 0) { return null; }
  return filteredAppointments[0];
};

export const buildAppointmentStatus = (appointment) => {
  const apptStatusId = _.get(appointment, 'eventStatus.id');
  let statusBg = '';
  for (const status in APPOINTMENT_STATUS) {
    const appt = APPOINTMENT_STATUS[status];
    if (appt.id === apptStatusId) {
      statusBg = appt.background;
    }
  }
  if ((moment() > moment(appointment.startDate)) &&
    (apptStatusId !== APPOINTMENT_STATUS.COMPLETED.id) &&
    (apptStatusId !== APPOINTMENT_STATUS.CANCELLED.id)) {
    return (
      <div className='appt-status-label'>
        {'PAST DUE'}
      </div>
    );
  } else {
    return (
      <div className={`appt-status-label bg-${statusBg}`}>
        {_.get(appointment, 'eventStatus.name', '')}
      </div>
    );
  }
};

const cancelAppointment = (appointment, disposition, history, isFromAppointmentDetails = false) => async (dispatch, getState) => {
  const response = await dispatch(updateAppointment(appointment, APPOINTMENT_STATUS.CANCELLED.id, disposition, appointment.startDate, appointment.endDate));
  if (isFromAppointmentDetails) {
    dispatch(showServerResponse(response, 'Appointment Cancelled', REASSIGNED_MESSAGE, history.length <= 2 ? '/dashboard' : () => dispatch(go(-2))));
  } else {
    dispatch(showServerResponse(response, 'Appointment Cancelled', REASSIGNED_MESSAGE, history.length < 2 ? '/dashboard' : () => dispatch(goBack())));
  }
  return response;
};

const completeAppointment = (appointment, disposition, history, isFromAppointmentDetails = false) => async (dispatch, getState) => {
  const response = await dispatch(updateAppointment(appointment, APPOINTMENT_STATUS.COMPLETED.id, disposition, appointment.startDate, appointment.endDate));
  if (isFromAppointmentDetails) {
    dispatch(showServerResponse(response, 'Appointment Completed', REASSIGNED_MESSAGE, history.length <= 2 ? '/dashboard' : () => dispatch(go(-2))));
  } else {
    dispatch(showServerResponse(response, 'Appointment Completed', REASSIGNED_MESSAGE, history.length < 2 ? '/dashboard' : () => dispatch(goBack())));
  }
  return response;
};

const rescheduleAppointment = (appointment, disposition, startDate, endTime, history, isFromAppointmentDetails = false) => async (dispatch, getState) => {
  const ss = endTime.split(':');
  const startDate1 = moment(startDate).toDate();
  const endDate = moment(startDate).hour(ss[0]).minute(ss[1]).toDate();
  if (ss[0] === '00') {
    endDate.setDate(endDate.getDate() + 1);
  }
  const response = await dispatch(updateAppointment(appointment, APPOINTMENT_STATUS.CONFIRMED.id, disposition, startDate1, endDate));
  if (isFromAppointmentDetails) {
    dispatch(showServerResponse(response, 'Appointment Rescheduled', REASSIGNED_MESSAGE, history.length <= 2 ? '/dashboard' : () => dispatch(go(-2))));
  } else {
    dispatch(showServerResponse(response, 'Appointment Rescheduled', REASSIGNED_MESSAGE, history.length < 2 ? '/dashboard' : () => dispatch(goBack())));
  }
  return response;
};

// TODO: revisit this after changing the API to return similar responses in all of the calendar events..
export const updateAppointment = (appointment, eventStatusId, dispositionId, startDate, endDate) => (dispatch, getState) => {
  var bodyDict = {};
  bodyDict.disposition = { DispositionKey: dispositionId };
  bodyDict.eventStatus = { CalendarEventStatusKey: eventStatusId };
  bodyDict.name = appointment.name;
  bodyDict.notes = appointment.notes;
  bodyDict.eventType = 'OpportunityAppointment';
  bodyDict.opportunityKeys = appointment.opportunityKeys;
  bodyDict.timestampStart = moment.utc(startDate || appointment.timestampStart || appointment.startDate).format();
  bodyDict.timestampEnd = moment.utc(endDate || appointment.timestampEnd || appointment.endDate).format();
  appointment.timeZone.timeZoneKey = appointment.timeZone.timeZoneKey || appointment.timeZone.id;
  bodyDict.timeZone = appointment.timeZone; // important, if missed the lead would be corrupted.
  bodyDict.description = appointment.description;
  bodyDict.priority = appointment.priority;
  const contactIDs = [];
  appointment.contactIDs.forEach((contact) => {
    contactIDs.push(contact.id);
  });
  bodyDict.contactKeys = contactIDs;
  return dispatch(putUpdateAppointment(appointment.id, bodyDict));
};

const toggleView = (isDateView) => (dispatch, getState) => {
  const { appointments = {} } = getState();
  dispatch({ type: APPOINTMENTS.TOGGLE_VIEW, isDateView: _.isBoolean(isDateView) ? isDateView : !appointments.isDateView });
};

const getFirstOverdueAppt = (appointments) => {
  if (!appointments || (appointments && !appointments[0])) { return null; }
  const appts = appointments.sort((a, b) => moment(a.startDate) - moment(b.startDate));

  for (const index in appts) {
    const appointment = appts[index];
    if (appointment && appointment.eventStatus && appointment.eventStatus.name !== 'Completed' && appointment.eventStatus.name !== 'Cancelled') { return moment(appointment.startDate); }
  }

  return moment(appts[0].startDate);
};

const changeActiveDate = (activeDate) => (dispatch) => {
  dispatch({ type: APPOINTMENTS.ACTIVE_DATE_CHANGED, value: activeDate });
};

export const appointmentActions = {
  fetch,
  getAppointmentById,
  fetchDispositions,
  cancelAppointment,
  rescheduleAppointment,
  completeAppointment,
  changeActiveDate,
  getFirstOverdueAppt,
  toggleView
};

const getAppointmentRank = (appointment) => {
  const id = appointment.eventStatus.calendarEventStatusKey || appointment.eventStatus.id;

  for (const key in APPOINTMENT_STATUS) {
    if (APPOINTMENT_STATUS[key].id === id) {
      return APPOINTMENT_STATUS[key].rank;
    }
  }
  return null;
};

export const sortApppointmentsByStatusRank = (app1, app2, isDesc = false) => {
  const comparator = getAppointmentRank(app1) - getAppointmentRank(app2);
  return !isDesc ? comparator : 0 - comparator;
};

export const sortAppointmentsByTime = (app1, app2, isDesc = false) => {
  const comparator = moment(app1.timestampStart) - moment(app2.timestampStart);
  return !isDesc ? comparator : 0 - comparator;
};

export const prioritizeAppointments = (appointments, isDesc = false) => {
  const sortedAppts = (appointments || []).sort((app1, app2) => {
    const rank = sortApppointmentsByStatusRank(app1, app2, isDesc);
    return rank > 0 || rank < 0 ? rank : sortAppointmentsByTime(app1, app2, isDesc);
  });
  return sortedAppts;
};
